import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getManagerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FieldStackedLabel } from '../../../../Field'
import {
  FormFieldsContainer,
  FormFieldSelectNG,
  getResponsibleManagersFieldErrorProps,
} from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../../../Select'
import {
  toUserSelectItemsFromOption,
  USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  UserMultiSelect,
} from '../../../../User'
import { BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS } from '../BuildingsEditManagersActionModal.constants'

function FormFields({ actionTypes }) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: { [BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS]: EMPTY_LIST },
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...getResponsibleManagersFieldErrorProps(
            errors[BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS]
          ),
          options: actionTypes,
        }}
      >
        <FormikField
          multi
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('Building.EditManagersFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          dropdownFloatingConfig={
            USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL
          }
          emptyValue={EMPTY_LIST}
          fieldComponentProps={{
            label: `${t('Building.EditManagersFieldLabelKey')}`,
          }}
          getData={getManagerProfileOptions}
          getDataItems={getItemsFromIdwellApiResponse}
          getErrorProps={getResponsibleManagersFieldErrorProps}
          listProps={{
            Footer: SelectDropdownListFooter,
            Header: SelectDropdownListHeader,
          }}
          name={BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS}
          toPreparedItems={toUserSelectItemsFromOption}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
